import { financeI18nEn } from './finance-i18n';
// USA
import { caseI18nEn } from './case-i18n';

export const locale = {
  lang: 'en',
  data: {
    ...financeI18nEn,
    ...caseI18nEn,
    SPLASH: {
      LOADING: 'Loading...',
    },
    PWA: {
      UPDATE_TITLE: 'New Update',
      UPDATE_TEXT: 'A new version of the app is available. Do you want to update now?',
      UPDATE_CONFIRM: 'Update',
      UPDATE_CANCEL: 'Later',
    },
    CONNECTION: {
      OFFLINE: 'No internet connection',
      SERVICE_UNREACHABLE: 'Cannot reach the app service',
    },
    ERRORS: {
      GENERIC: 'An unexpected error occurred. Please try again.',
      NETWORK: 'Unable to reach the server. Please check your internet connection.',
      BAD_REQUEST: 'The request is invalid. Please check the information and try again.',
      UNAUTHORIZED: 'Your session has expired. Please sign in again.',
      FORBIDDEN: 'You do not have permission to perform this action.',
      NOT_FOUND: 'The requested record could not be found.',
      CONFLICT: 'This action conflicts with an existing record.',
      VALIDATION: 'Some of the provided information is invalid. Please check and try again.',
      TOO_MANY_REQUESTS: 'Too many requests were sent. Please wait a moment and try again.',
      SERVER: 'A server error occurred. Please try again later.',
      EMAIL_IN_USE: 'This email address is already in use.',
      INVALID_CREDENTIALS: 'The email or password is incorrect.',
      USER_NOT_ACTIVE: 'The user account is not active.',
      USER_NOT_ALLOWED: 'The user account is not allowed to log in.',
    },
    HTTP_ERROR_TOAST: {
      TITLE: 'An error occurred',
      COPY: 'Copy',
      COPY_ALL: 'Copy All ({{count}})',
      COPIED_SUCCESSFULLY: 'Copied successfully',
      ATTEMPT_COUNT: '{{count}} attempt(s) recorded',
      DISMISS: 'Dismiss error',
      DISMISS_ALL: 'Dismiss all errors',
    },
    ERROR_PAGE: {
      PAGE_404_TITLE: 'Oops!',
      PAGE_404_MESSAGE: "We can't find that page.",
      PAGE_500_TITLE: 'System Error',
      PAGE_500_MESSAGE: 'Something went wrong! Please try again later.',
      RETURN_HOME: 'Return Home',
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications',
      EMPTY: 'No notifications yet.',
      MARK_ALL_READ: 'Mark all read',
      CLEAR_ALL: 'Clear all',
      MARK_READ: 'Mark as read',
      DELETE: 'Delete',
      ACTIONS: 'Actions',
      CLEAR_ALL_CONFIRM_TITLE: 'Clear all notifications?',
      CLEAR_ALL_CONFIRM_MESSAGE: 'This will permanently remove all notifications from your inbox.',
      PAGE_SUBTITLE: 'View and manage your notifications',
      TEMPLATES: {
        WORK_COMPLETED: {
          TITLE: 'Work completed',
          BODY: '{{work}} has been completed for vehicle {{plate}} ({{caseNo}}).',
        },
        WORK_ASSIGNED_TO_UNIT: {
          TITLE: 'Work assigned to unit',
          BODY: '{{work}} was assigned to {{workshop}} for vehicle {{plate}} ({{caseNo}}).',
        },
        TECHNICIAN_ASSIGNED: {
          TITLE: 'Work assigned to you',
          BODY: 'You were assigned to {{work}} for vehicle {{plate}} ({{caseNo}}).',
        },
        CASE_STATUS_CHANGED: {
          TITLE: 'Case status updated',
          BODY: 'Vehicle {{plate}} ({{caseNo}}) changed from {{previousStatus}} to {{newStatus}}.',
        },
        CASE_CHAT_MESSAGE: {
          TITLE_WITH_PLATE: 'New message on vehicle {{plate}}',
          TITLE_WITH_CASE: 'New message on {{caseNo}}',
          BODY: '{{senderName}}: {{messagePreview}}',
        },
        VEHICLE_REGISTERED: {
          TITLE: 'New vehicle registered',
          BODY: 'Vehicle {{plate}} ({{caseNo}}) has been registered and is waiting for damage analysis.',
        },
        DAMAGE_INFORMATION_COMPLETED: {
          TITLE: 'Damage information entered',
          BODY: 'Damage analysis for vehicle {{plate}} ({{caseNo}}) is completed and awaiting your approval.',
        },
        SERVICE_MANAGER_APPROVED: {
          TITLE: 'Service approval granted',
          BODY: 'Vehicle {{plate}} ({{caseNo}}) has been approved by the service manager.',
        },
        PART_TRACKING_REQUIRED: {
          TITLE: 'Part tracking required',
          BODY: 'Tracking is required for {{partCount}} part(s) on vehicle {{plate}} ({{caseNo}}).',
        },
        DAMAGE_ANALYSIS_RETURNED: {
          TITLE: 'Damage analysis returned',
          BODY: 'Damage analysis for vehicle {{plate}} ({{caseNo}}) was returned by the service manager.',
        },
        SERVICE_REVIEW_SENT: {
          TITLE: 'Service review pending',
          BODY: 'Vehicle {{plate}} ({{caseNo}}) has completed workshop control and is awaiting service chief approval.',
        },
        BOOKING_RECEIVED: { TITLE: 'New booking received', BODY: '{{bookingSource}} booking received for {{plate}}.' },
        ARRIVAL_APPOINTMENT_SCHEDULED: { TITLE: 'Arrival appointment scheduled', BODY: '{{plate}} arrival is planned for {{appointmentDateTime}}.' },
        DELIVERY_APPOINTMENT_SCHEDULED: { TITLE: 'Delivery appointment scheduled', BODY: '{{appointmentIdentity}} delivery is planned for {{appointmentDateTime}}.' },
        APPOINTMENT_REMINDER: { TITLE: 'Appointment reminder', BODY: '{{appointmentIdentity}} is planned for {{appointmentDateTime}}.' },
        REPEAT_WORK_STATUS_CHANGED: { TITLE: 'Repeat work updated', BODY: 'Repeat #{{repeatSequence}} for {{plate}} was updated.' },
        REPEAT_DELIVERY_READY: { TITLE: 'Repeat ready for delivery', BODY: 'Repeat #{{repeatSequence}} for {{plate}} is ready for delivery.' },
        REPEAT_DELIVERED: { TITLE: 'Repeat delivery completed', BODY: 'Repeat #{{repeatSequence}} for {{plate}} was delivered.' },
        INVOICE_ISSUED: { TITLE: 'Invoice issued', BODY: 'The invoice for {{plate}} ({{caseNo}}) was marked as issued.' },
        INVOICE_UNISSUED: { TITLE: 'Invoice unissued', BODY: 'The invoice for {{plate}} ({{caseNo}}) was marked as not issued.' },
        INVOICE_COLLECTED: { TITLE: 'Invoice collected', BODY: 'The invoice for {{plate}} ({{caseNo}}) was marked as collected.' },
        INVOICE_COLLECTION_REVERTED: { TITLE: 'Invoice collection cleared', BODY: 'The collection mark for {{plate}} ({{caseNo}}) was cleared.' },
        CASE_DELETION_REQUESTED: { TITLE: 'Case deletion requested', BODY: '{{requesterName}} requested deletion of {{target}} for {{plate}} ({{caseNo}}).' },
      },
    },
    MENU: {
      DASHBOARD: 'Service Status Panel',
      USERS: 'Users',
      CASE: 'Vehicles in Service',
      CALENDAR: 'Calendar',
      WORKLIST: 'Workshop Tracking',
      SELF_BOOKING: 'Bookings',
      CUSTOMERS: 'Customer List',
      FOLLOWED_CASES: 'Tracked Cases',
      ACCOUNTING: 'Accounting',
      ROLE_MANAGEMENT: 'Role Management',
      NOTIFICATIONS: 'Notifications',
    },
    ROLE_MANAGEMENT: {
      TITLE: 'Role Management', SUBTITLE: 'Select the permissions available to each role.', ROLE: 'Role',
      ADMIN_LOCKED: 'Admin always has full access and cannot be edited.', SAVE: 'Save permissions', SAVING: 'Saving...',
      SAVED: 'Permissions saved.', LOADING: 'Loading permissions...', LOAD_ERROR: 'Permissions could not be loaded.',
      SAVE_ERROR: 'Permissions could not be saved.', PERMISSIONS: 'permissions',
      MODULES: { 'page-access': 'Page Access', dashboard: 'Dashboard', identity: 'Identity', cases: 'Case Management', worklist: 'Worklist', calendar: 'Calendar', 'customer-bookings': 'Customer Bookings', customers: 'Customers', accounting: 'Accounting', performance: 'Performance' },
      FEATURES: { pages: 'Pages', overview: 'Overview', roles: 'Roles', users: 'Users', listing: 'Case Listing', 'deletion-requests': 'Deletion Requests', 'damage-analysis': 'Work Order Management', documents: 'Documents', billing: 'Billing', delivery: 'Delivery', 'time-management': 'Time Management', 'work-orders': 'Work Orders', calendar: 'Calendar', bookings: 'Bookings', profiles: 'Profiles', reports: 'Reports', tracking: 'Tracking' },
      PERMISSION_DESCRIPTIONS: {
        DASHBOARD_VIEW: 'View vehicle and appointment counts, upcoming appointments, recent case activity, case-status distribution, and the workshop-tracking summary on the dashboard.',
        USERS_VIEW: 'Open the Users page and view accounts, assigned roles, contact details, account status, and employment information. Editing and password resets require Manage users.',
        USERS_MANAGE: 'Create and delete users; edit personal/contact details, role, active status, and employment dates; reset another user\'s password. The Users page also requires View users. Role-permission configuration remains Admin-only.',
        CASES_VIEW: 'Open case lists, tracked cases, workshop tracking, case details, and the Work Orders tab; export the case-list report. Appraisal, documents, billing, and delivery tabs have separate viewing permissions.',
        CASES_MANAGE: 'Register a case, including from a customer booking; edit registration, customer, vehicle, insurance/policy, and Damage & Insurance information. This includes notification and damage date/time, location, cause, and estimated amount before delivery. Use document auto-fill during registration. Does not grant work-order pricing or case-deletion access.',
        CASE_DELETE: 'Delete a case directly from the case list and release its delivery appointment slot. The record is marked as deleted and retained in the database. A pending deletion request must be resolved first.',
        CASE_DELETION_REQUEST_CREATE: 'Non-admin users can request deletion of a case or cancellation of a repeat work order, and withdraw only their own pending request. Submitting a request does not itself delete the case or cancel the work.',
        CASE_DELETION_REQUEST_REVIEW: 'Review and reject pending case-deletion or repeat-work cancellation requests. Confirming case deletion additionally requires Delete cases; confirming repeat-work cancellation requires Admin access.',
        DAMAGE_VIEW: 'Open the Appraisal tab to inspect the damage map, recorded damage items, assigned workshops, work-order descriptions, notes, and spare-part quantities. Required arrival photos must be completed before the analysis workspace opens.',
        DAMAGE_MANAGE: 'Upload required arrival photos; edit the damage map, appraisal work orders, parts and quantities; add additional work orders; approve analysis and withdraw approval when allowed. Damage & Insurance information is managed with Manage cases.',
        DOCUMENTS_VIEW: 'Open the Documents and Official Forms tabs; view uploaded documents/photos, download generated forms, and print individual or combined work-order documents.',
        DOCUMENTS_MANAGE: 'Upload and delete case documents/photos, assign documents to categories, update additional documents and mandatory-document requirements, and generate registration print previews. Document requirements can be edited before delivery.',
        BILLING_VIEW: 'Open the case Invoice tab to view work-order labor prices, spare-part unit prices, extra services, discounts, VAT/adjustments, totals, and whether the invoice has been issued.',
        BILLING_MANAGE: 'In the Invoice tab, edit labor and part prices, add/edit service amounts, configure discounts and VAT/adjustments, convert legacy billing, and mark the invoice issued or not issued. Price edits require unlocked billing; opening the tab also requires View billing.',
        DELIVERY_VIEW: 'Open the Delivery tab for cases and repeat work to inspect delivery readiness, appointment information, delivery documents/photos, and signature information.',
        DELIVERY_MANAGE: 'Schedule or change delivery appointments for cases and repeat work, save the delivery signature, and complete delivery once readiness requirements are met. Delivery photos/documents are managed with the document permissions.',
        CASE_TIMESTAMPS_MANAGE: 'Open Update Times and correct case registration, invoice issue, delivery and signature times; case/work-order status-event times; work-order creation, additional-work approval, delivery appointment, and actual delivery times.',
        WORK_ORDER_MANAGE: 'Assign/remove technicians; edit parts, supply status and notes; approve/reject completion and revert workshop approval; approve/cancel additional work and create repeat work. Can start, pause, resume and complete assigned jobs on behalf of technicians. Direct repeat-work cancellation is Admin-only; initial appraisal/additional-work creation needs Manage damage analysis.',
        CALENDAR_VIEW: 'Open the calendar, view arrival and delivery appointments, and export the delivery-appointment report. Creating/changing bookings requires Manage bookings; case delivery scheduling requires Manage delivery.',
        BOOKINGS_VIEW: 'Open the Bookings page and inspect customer requests, contact and vehicle details, arrival appointment, description, and attached documents.',
        BOOKINGS_MANAGE: 'Create manual bookings; edit customer/contact/vehicle details and attached documents; schedule or change arrival appointments; delete bookings. Opening a case from a booking additionally requires Manage cases.',
        CUSTOMERS_VIEW: 'Open Customer List; search by customer or plate, view mileage, visit count and last service date, and inspect the service-history timeline of registrations, appointments, deliveries and repeat work. Opening a linked case requires View cases.',
        ACCOUNTING_VIEW: 'Open Accounting to review invoiced revenue by period, labor/parts/extra-service breakdowns and contributing cases; download accounting, labor, spare-parts and additional-service reports.',
        ACCOUNTING_MANAGE: 'Currently grants no additional editing action: the Accounting page contains reports only. Case labor/part prices, services, discounts and invoice status are edited with Manage billing.',
        PERFORMANCE_VIEW: 'Open Performance to compare employees by completed and active jobs and average completion time for weekly/monthly/yearly periods; inspect workshop breakdowns and employee activity details.',
      },
    },
    PERMISSIONS: {
      DASHBOARD_VIEW: 'View dashboard', USERS_VIEW: 'View users', USERS_MANAGE: 'Manage users', CASES_VIEW: 'View cases', CASES_MANAGE: 'Manage cases', CASE_DELETE: 'Delete cases', CASE_DELETION_REQUEST_CREATE: 'Request case deletion', CASE_DELETION_REQUEST_REVIEW: 'Review case deletion requests', DAMAGE_VIEW: 'View damage analysis', DAMAGE_MANAGE: 'Manage damage analysis', DOCUMENTS_VIEW: 'View documents', DOCUMENTS_MANAGE: 'Manage documents', BILLING_VIEW: 'View billing', BILLING_MANAGE: 'Manage billing', DELIVERY_VIEW: 'View delivery', DELIVERY_MANAGE: 'Manage delivery', CASE_TIMESTAMPS_MANAGE: 'Manage timestamps', WORK_ORDER_MANAGE: 'Manage work orders', CALENDAR_VIEW: 'View calendar', BOOKINGS_VIEW: 'View bookings', BOOKINGS_MANAGE: 'Manage bookings', CUSTOMERS_VIEW: 'View customers', ACCOUNTING_VIEW: 'View accounting', ACCOUNTING_MANAGE: 'Manage accounting', PERFORMANCE_VIEW: 'View performance',
    },
    ACCOUNTING: {
      COLLECTIONS_MORE_ERROR: 'More collection records could not be loaded.',
      COLLECTIONS_LOAD_ERROR: 'Collections for this period could not be loaded.',
      COLLECTIONS_LOADING: 'Loading collections...',
      COLLECTIONS_CONTRIBUTORS_TITLE: 'Cases with collections in this period',
      TOTAL_COLLECTED: 'Total collected',
      COLLECTIONS_BREAKDOWN_TITLE: 'Collection breakdown',
      COLLECTIONS_AXIS_LABEL: 'Amounts collected during the selected period (TRY)',
      COLLECTIONS_EMPTY: 'No collections were found in the selected period.',
      COLLECTIONS_CHART_TITLE: 'Period collections',
      COLLECTIONS_SUBTITLE: 'Review collections made during the selected period, by collection date.',
      SYNC_FRESHNESS: "Oldest data synchronization:",
      SYNC_FAILURES: "{{count}} record(s) could not be synchronized. Amounts reflect the last successful synchronization.",

      TITLE: 'Accounting',
      SUBTITLE: 'Review financial performance and accounting documents.',
      LIFECYCLE_SELECTOR: 'Invoice lifecycle filter',
      LIFECYCLE_ALL: 'All',
      LIFECYCLE_ISSUED: 'Historical Invoice Issued',
      LIFECYCLE_COLLECTED: 'Collections',
      PERIOD_SELECTOR: 'Accounting reporting period',
      PERIOD_YEAR: 'Year',
      PERIOD_MONTH: 'Month',
      PERIOD_WEEK: 'Week',
      DATE_NAVIGATION: 'Date navigation',
      PREVIOUS_PERIOD: 'Previous period',
      NEXT_PERIOD: 'Next period',
      EXPORT_REPORT: 'Export Accounting Report',
      EXPORT_DISABLED: 'Report export will be available soon.',
      REPORT_DOWNLOAD_ERROR: 'The accounting report could not be downloaded. Please try again.',
      LABOR_REPORT_DOWNLOAD_ERROR: 'The labor report could not be downloaded. Please try again.',
      PARTS_REPORT_DOWNLOAD_ERROR: 'The spare-parts report could not be downloaded. Please try again.',
      ADDITIONAL_SERVICES_REPORT_DOWNLOAD_ERROR: 'The additional-services report could not be downloaded. Please try again.',
      CHART_TITLE: 'Financial Overview',
      CHART_SKELETON_LABEL: 'Financial overview chart preview',
      CHART_LOADING: 'Loading...',
      CHART_LOAD_ERROR: 'Cash flow data could not be loaded.',
      CHART_EMPTY: 'No invoice revenue was found for the selected filter.',
      CASH_FLOW_AXIS_LABEL: 'Gross revenue from the selected invoice lifecycle',
      RETRY: 'Retry',
      BREAKDOWN_TITLE: 'Breakdown',
      BREAKDOWN_SKELETON_LABEL: 'Accounting breakdown preview',
      BREAKDOWN_LOADING: 'Loading...',
      BREAKDOWN_LOAD_ERROR: 'Billing breakdown could not be loaded.',
      BREAKDOWN_EMPTY: 'No billed amounts were found for this period.',
      TOTAL_BILLED: 'Total billed',
      LABOR_BILLED: 'Labor',
      SPARE_PARTS_BILLED: 'Spare parts',
      ADDITIONAL_SERVICES_BILLED: 'Additional services',
      REVENUE_DISTRIBUTION: 'Revenue Distribution',
      REVENUE_DISTRIBUTION_LABEL: 'Revenue distribution: Labor {{labor}} ({{laborShare}}%), spare parts {{parts}} ({{partsShare}}%), additional services {{services}} ({{servicesShare}}%).',
      REPORT_ACTIONS: 'Category report actions',
      EXPORT_LABOR_REPORT: 'Export Labor Report',
      EXPORT_PARTS_REPORT: 'Export Parts Report',
      EXPORT_ADDITIONAL_SERVICES_REPORT: 'Export Additional Services Report',
      REPORT_DISABLED: 'Category report export will be available soon.',
      LABOR_REPORT_DISABLED: 'Export labor report. Category report export will be available soon.',
      PARTS_REPORT_DISABLED: 'Export spare parts report. Category report export will be available soon.',
      ADDITIONAL_SERVICES_REPORT_DISABLED: 'Export additional services report. Category report export will be available soon.',
      DOCUMENTS_TITLE: 'Documents',
      DOCUMENTS_SKELETON_LABEL: 'Accounting documents preview',
      CONTRIBUTORS_TITLE: 'Contributing cases',
      CONTRIBUTORS_LOADING: 'Loading...',
      CONTRIBUTORS_LOAD_ERROR: 'Contributing cases could not be loaded.',
      CONTRIBUTORS_EMPTY: 'No cases contributed to this period.',
      CONTRIBUTORS_LOADING_MORE: 'Loading more...',
      CONTRIBUTORS_LOAD_MORE_ERROR: 'More contributing cases could not be loaded.',
      OPEN_CONTRIBUTING_CASE: 'Open case',
      COLUMN_PLATE: 'Plate',
      COLUMN_CUSTOMER: 'Customer',
      COLUMN_INVOICE_ISSUED_AT: 'Invoice date',
      COLUMN_INVOICE_COLLECTION_PAYMENT_METHOD: 'Account / method',
      COLUMN_STATUS: 'Status',
      COLUMN_LABOR: 'Labor',
      COLUMN_SPARE_PARTS: 'Spare parts',
      COLUMN_ADDITIONAL_SERVICES: 'Additional services',
      COLUMN_TOTAL_BILLED: 'Total billed',
    },
    SIDEBAR: {
      COLLAPSE: 'Collapse sidebar',
      EXPAND: 'Expand sidebar',
    },
    PAGINATION: {
      LABEL: 'Pagination',
      ROWS_PER_PAGE: 'Rows per page',
      PREVIOUS: 'Previous page',
      NEXT: 'Next page',
    },
    CALENDAR: {
      INDICATOR_LEGEND_LABEL: 'Calendar indicator meanings',
      INDICATOR_DELIVERED: 'Delivered',
      INDICATOR_MISSED: 'Missed delivery',
      INDICATOR_SCHEDULED: 'Scheduled delivery',
      INDICATOR_ARRIVAL: 'Scheduled arrival',
      INDICATOR_TODAY: 'Today',
      REPORT_DOWNLOAD: 'Export Report',
      REPORT_DOWNLOADING: 'Preparing report...',
      REPORT_DOWNLOAD_ERROR: 'The report could not be downloaded. Please try again.',
      SHOW_COMPLETED_APPOINTMENTS: 'Show completed',
      DELIVERY_APPOINTMENTS_LOADING_MORE: 'Loading more appointments...',
      DELIVERY_APPOINTMENTS_LOAD_MORE_ERROR: 'More appointments could not be loaded.',
      COLUMN_DELIVERY: 'Delivery date',
      COLUMN_APPOINTMENT_TYPE: 'Appointment type',
      COLUMN_APPOINTMENT_DATE: 'Appointment date',
      RETRY: 'Retry',
      LIST_ALL_APPOINTMENTS: 'List All Appointments',
      ALL_APPOINTMENTS_TITLE: 'All Appointments',
      ALL_APPOINTMENTS_EMPTY: 'No upcoming appointments were found.',
      DELIVERY_APPOINTMENTS_TITLE: 'Delivery Appointments',
      DELIVERY_APPOINTMENTS_LOADING: 'Loading delivery appointments...',
      DELIVERY_APPOINTMENTS_EMPTY: 'No upcoming delivery appointments were found.',
      DELIVERY_APPOINTMENTS_LOAD_ERROR: 'Delivery appointments could not be loaded. Please try again.',
      TITLE: 'Calendar',
      SUBTITLE: 'Plan and track arrival and delivery appointments.',
      CONTROLS_LABEL: 'Calendar controls',
      VIEW_SELECTOR: 'Calendar view',
      VIEW_MONTH: 'Month',
      VIEW_WEEK: 'Week',
      VIEW_DAY: 'Day',
      PREVIOUS_PERIOD: 'Previous period',
      NEXT_PERIOD: 'Next period',
      MORE_APPOINTMENTS: 'More appointments are available',
      OUTSIDE_HOURS: 'Appointments outside service hours',
      PREVIOUS_YEAR: 'Previous year',
      NEXT_YEAR: 'Next year',
      DISPLAY_DELIVERED: 'Display delivered',
      SCHEDULE_NEW_DELIVERY: 'New Delivery Appointment',
      SCHEDULE_NEW_APPOINTMENT: 'Schedule New Appointment',
      CREATE_MANUAL_BOOKING: 'Create New Customer',
      MANUAL_BOOKING_TITLE: 'Manual Customer Booking',
      MANUAL_BOOKING_EDIT_TITLE: 'Edit Booking',
      MANUAL_BOOKING_SUBTITLE: 'Enter customer details, the arrival appointment, and optional documents.',
      MANUAL_BOOKING_FIRST_NAME: 'First name',
      MANUAL_BOOKING_LAST_NAME: 'Last name',
      MANUAL_BOOKING_DOCUMENTS: 'Documents',
      MANUAL_BOOKING_DOCUMENTS_OPTIONAL: 'Adding documents is optional.',
      MANUAL_BOOKING_EXISTING_DOCUMENTS: 'Existing documents ({{count}})',
      MANUAL_BOOKING_NEW_DOCUMENTS: 'New documents',
      MANUAL_BOOKING_ADD_DOCUMENTS: 'Add Documents',
      MANUAL_BOOKING_REMOVE_DOCUMENT: 'Remove document {{name}}',
      MANUAL_BOOKING_UNDO_DOCUMENT_REMOVAL: 'Undo',
      MANUAL_BOOKING_DOCUMENT_PENDING_REMOVAL: 'Removed on save',
      MANUAL_BOOKING_DOCUMENT_REMOVAL_ERROR: 'Document changes could not be saved. No documents were removed.',
      MANUAL_BOOKING_DOCUMENT_COUNT_ERROR: 'A maximum of {{count}} documents can be added.',
      MANUAL_BOOKING_DOCUMENT_INVALID_ERROR: 'The selected document type or size is not valid.',
      MANUAL_BOOKING_DOCUMENT_TOTAL_SIZE_ERROR: 'The total document size exceeds the allowed limit.',
      MANUAL_BOOKING_SAVE: 'Create Booking',
      MANUAL_BOOKING_UPDATE: 'Save changes',
      MANUAL_BOOKING_SAVE_ERROR: 'The manual customer booking could not be created. Please try again.',
      MANUAL_BOOKING_UPDATE_ERROR: 'The booking could not be updated. Please try again.',
      MANUAL_BOOKING_REQUIRED_ERROR: 'This field is required.',
      MANUAL_BOOKING_EMAIL_ERROR: 'Enter a valid email address.',
      MANUAL_BOOKING_PHONE_ERROR: 'Enter a valid phone number.',
      MANUAL_BOOKING_INVALID_ERROR: 'Enter a valid value.',
      MANUAL_BOOKING_APPOINTMENT_PAIR_ERROR: 'Select both an arrival date and time, or leave both blank.',
      CANCEL_SCHEDULING: 'Cancel delivery appointment scheduling',
      SCHEDULING_INSTRUCTION: 'Choose an appointment day for {{plate}}.',
      ARRIVAL_SCHEDULING_INSTRUCTION: 'Choose an arrival appointment day for {{plate}}.',
      APPOINTMENT_CANDIDATES_TITLE: 'Select an appointment',
      APPOINTMENT_CANDIDATES_SUBTITLE: 'Choose a record for a delivery or arrival appointment.',
      DELIVERY_CANDIDATES_TITLE: 'Select a case',
      DELIVERY_CANDIDATES_SUBTITLE: 'Choose an undelivered case for a delivery appointment.',
      DELIVERY_CANDIDATES_SEARCH_LABEL: 'Search vehicle plate',
      DELIVERY_CANDIDATES_SEARCH_PLACEHOLDER: 'Search by vehicle plate',
      DELIVERY_CANDIDATES_LOADING: 'Loading cases...',
      DELIVERY_CANDIDATES_EMPTY: 'No matching undelivered cases were found.',
      DELIVERY_CANDIDATES_LOAD_ERROR: 'Cases could not be loaded. Please try again.',
      DELIVERY_APPOINTMENT_TITLE: 'Create Delivery Appointment',
      DELIVERY_APPOINTMENT_SELECTION_TITLE: 'Set a Delivery Appointment for {{plate}} · {{customer}}',
      DELIVERY_APPOINTMENT_DATE: 'Delivery date',
      DELIVERY_APPOINTMENT_TIME: 'Delivery time',
      DELIVERY_APPOINTMENT_TIME_REQUIRED: 'Enter a valid delivery time.',
      DELIVERY_APPOINTMENT_SAVE_ERROR: 'The delivery appointment could not be saved. Please try again.',
      REMOVE_APPOINTMENT: 'Remove appointment',
      APPOINTMENT_REMOVE_ERROR: 'The appointment could not be removed. Please try again.',
      APPOINTMENT_SLOT_UNAVAILABLE: 'This time slot is full. Please choose another time.',
      ARRIVAL_APPOINTMENT_TITLE: 'Create Arrival Appointment',
      ARRIVAL_APPOINTMENT_DATE: 'Arrival date',
      ARRIVAL_APPOINTMENT_TIME: 'Arrival time',
      ARRIVAL_APPOINTMENT_TIME_REQUIRED: 'Enter a valid arrival time.',
      ARRIVAL_APPOINTMENT_SAVE_ERROR: 'The arrival appointment could not be saved. Please try again.',
      COLUMN_STATUS: 'Status',
      COLUMN_EXPECTED_DELIVERY: 'Delivery appointment',
      COLUMN_EXPECTED_APPOINTMENT: 'Planned appointment',
      CANCEL: 'Cancel',
      CONFIRM: 'Confirm',
      LOADING: 'Loading calendar events...',
      LOAD_ERROR: 'Calendar events could not be loaded. Please try again.',
      DAY_EVENT_COUNT: '{{count}} appointment events',
      DAY_EVENTS_TITLE: 'Appointments',
      COLUMN_PLATE: 'Vehicle plate',
      COLUMN_TIME: 'Time',
      COLUMN_EVENT: 'Event',
      EVENT_TYPE_1: 'Delivery appointment',
      EVENT_TYPE_2: 'Arrival appointment',
      EVENT_TYPE_RECEIVED: 'Received',
      EVENT_TYPE_DELIVERED: 'Delivered',
      CLOSE: 'Close',
    },
    SELF_BOOKING: {
      ARRIVAL_APPOINTMENT_SELECTION_TITLE: 'Set an Arrival Appointment for {{plate}} · {{customer}}',
      ARRIVAL_APPOINTMENT_CALENDAR_LABEL: 'Monthly calendar for the arrival appointment',
      REFRESH: 'Refresh',
      REFRESHING: 'Refreshing',
      FILTER: 'Filter',
      FILTER_APPLY: 'Apply',
      FILTER_CLEAR: 'Clear',
      FILTER_CANCEL: 'Cancel',
      FILTER_ALL: 'All',
      FILTER_CUSTOMER_PLACEHOLDER: 'Filter by name',
      FILTER_PHONE_PLACEHOLDER: 'Filter by phone',
      FILTER_PLATE_PLACEHOLDER: 'Filter by plate',
      FILTER_EXPECTED_ARRIVAL_FROM: 'Expected arrival from',
      FILTER_EXPECTED_ARRIVAL_TO: 'Expected arrival to',
      FILTER_SUBMITTED_FROM: 'Submitted from',
      FILTER_SUBMITTED_TO: 'Submitted to',
      TITLE: 'Bookings',
      SUBTITLE: 'View customer booking requests from all channels.',
      TOTAL_RECORDS: '{{count}} records',
      CARD_TITLE: 'New Booking',
      CARD_TITLE_WEB: 'Website Appointment',
      CARD_TITLE_WHATSAPP: 'WhatsApp Appointment',
      CARD_TITLE_MANUAL: 'Manual Appointment',
      SOURCE: 'Source',
      SOURCE_WEBSITE: 'Website',
      SOURCE_WHATSAPP: 'WhatsApp',
      SOURCE_MANUAL: 'Manual',
      SUBMITTED_DATE: 'Submitted',
      COLUMN_CUSTOMER: 'Customer',
      COLUMN_EXPECTED_ARRIVAL: 'Expected Arrival',
      COLUMN_DOCUMENTS: 'Documents',
      VIEW_RECORD: 'View booking details',
      DETAIL_TITLE: 'Booking Details',
      CLOSE_DETAIL: 'Close booking details',
      PREVIEW_DOCUMENT: 'Preview document {{number}}',
      DOCUMENT_PREVIEW_PREVIOUS: 'Show previous booking document',
      DOCUMENT_PREVIEW_NEXT: 'Show next booking document',
      UNVIEWED_ALERT: 'There are unviewed bookings',
      NEW_CARD_ALERT: 'New booking',
      NAME_SURNAME: 'Name Surname',
      TCKN: 'Turkish ID Number',
      VEHICLE_PLATE: 'Vehicle plate',
      PHONE: 'Phone',
      EMAIL: 'Email',
      DESCRIPTION: 'Description',
      DOCUMENTS: 'Documents ({{count}})',
      NOT_SPECIFIED: 'Not specified',
      SHOW_MORE: 'Show more',
      SHOW_LESS: 'Show less',
      NO_DOCUMENTS: 'No documents submitted',
      DOCUMENT_ALT: 'Customer document {{number}}',
      LOADING: 'Loading bookings...',
      LOAD_ERROR: 'Customer bookings could not be loaded. Please try again.',
      RETRY: 'Try again',
      EMPTY_STATE: 'There are no new bookings.',
      COMPLETE: 'Complete Booking',
      COMPLETE_ARIA: 'Complete the booking for {{customer}}',
      COMPLETE_TOOLTIP: 'Complete customer booking',
      EXPECTED_ARRIVAL_DATE: 'Expected arrival date',
      EXPECTED_ARRIVAL_TIME: 'Expected arrival time',
      EDIT_BOOKING: 'Edit Booking',
      SET_APPOINTMENT_DATE: 'Set Appointment Date',
      UPDATE_APPOINTMENT_DATE: 'Update Appointment Date',
      APPOINTMENT_SAVE_ERROR: 'The appointment could not be saved. Please try again.',
      DELETE: 'Delete booking',
      DELETE_ARIA: 'Delete the booking for {{customer}}',
      DELETE_CONFIRM_TITLE: 'Delete customer booking',
      DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete the booking submitted by {{customer}}?',
      DELETE_CONFIRM_ACTION: 'Delete',
      DELETE_CANCEL: 'Cancel',
      DELETE_ERROR: 'The customer booking could not be deleted. Please try again.',
      PAGINATION_ARIA: 'Customer booking pages',
      PREVIOUS_PAGE: 'Previous page',
      NEXT_PAGE: 'Next page',
    },
    CUSTOMER_LIST: {
      TITLE: 'Customer List',
      SUBTITLE: 'Review service history by customer and vehicle.',
      SEARCH_LABEL: 'Search customer or vehicle',
      CUSTOMER_SEARCH_LABEL: 'Customer name',
      PLATE_SEARCH_LABEL: 'Vehicle plate',
      COLUMN_CUSTOMER: 'Customer',
      COLUMN_PHONE: 'Phone',
      COLUMN_PLATE: 'Plate',
      COLUMN_VEHICLE_MODEL: 'Vehicle Model',
      COLUMN_MILEAGE: 'Mileage',
      COLUMN_VISIT_COUNT: 'Visits',
      COLUMN_LAST_SERVICE: 'Last Service',
      LOADING: 'Loading customers...',
      EMPTY: 'No customer vehicles found.',
      LOAD_ERROR: 'Customer records could not be loaded. Please try again.',
      RETRY: 'Try again',
      TIMELINE_TITLE: 'Service Timeline',
      TIMELINE_CREATE_CASE: 'Create New Record',
      TIMELINE_CLOSE: 'Close timeline',
      TIMELINE_LOADING: 'Loading service history...',
      TIMELINE_ERROR: 'Service history could not be loaded.',
      TIMELINE_EMPTY: 'No service activity found for this vehicle.',
      TIMELINE_GO_TO_CASE: 'Go to Case',
      TIMELINE_CASE: 'Case',
      TIMELINE_WORK_ORDER: 'Work order',
      TIMELINE_EVENT_ARRIVAL_APPOINTMENT: 'Arrival appointment booked',
      TIMELINE_EVENT_CASE_CREATED: 'Case created',
      TIMELINE_EVENT_VEHICLE_ARRIVAL: 'Vehicle arrived',
      TIMELINE_EVENT_CASE_DELIVERED: 'Case delivered',
      TIMELINE_EVENT_CASE_DELIVERY_APPOINTMENT: 'Delivery appointment scheduled',
      TIMELINE_EVENT_REPEAT_CREATED: 'Repeat work order created',
      TIMELINE_EVENT_REPEAT_CANCELLED: 'Repeat work order cancelled',
      TIMELINE_EVENT_REPEAT_DELIVERED: 'Repeat work order delivered',
      TIMELINE_EVENT_REPEAT_DELIVERY_APPOINTMENT: 'Repeat work order delivery appointment scheduled',
    },
    USER_MENU: {
      CHANGE_PASSWORD: 'Change Password',
      CHANGE_PASSWORD_DESCRIPTION: 'Set your new password.',
      NEW_PASSWORD: 'New Password',
      NEW_PASSWORD_CONFIRM: 'Confirm New Password',
      PASSWORD_REQUIRED: 'Password is required',
      PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters long',
      PASSWORDS_MUST_MATCH: 'Passwords do not match',
      CANCEL: 'Cancel',
      SAVE_PASSWORD: 'Save Password',
      PLEASE_WAIT: 'Please wait...',
      CLOSE: 'Close',
      PASSWORD_CHANGE_SUCCESS_TITLE: 'Success!',
      PASSWORD_CHANGE_SUCCESS: 'Your password has been updated successfully.',
      LANGUAGE: 'Language',
      SIGN_OUT: 'Sign Out',
    },
    CRUD: {
      NO_RECORDS: 'No records found.',
      ACTIONS: 'Actions',
      DELETE_CONFIRM_TITLE: 'Are you sure you want to delete {{userName}}?',
      DELETE_CONFIRM_TEXT: 'This cannot be undone.',
      LOADING: 'Loading...',
      CONFIRM_DELETE: 'Delete',
      CANCEL: 'Cancel',
    },
    SELECT: {
      SEARCH: 'Search options',
      NO_RESULTS: 'No matching options',
    },
    DATE_PICKER: {
      FORMAT: 'dd/mm/yyyy',
    },
    APPOINTMENT_SLOT_PICKER: {
      SELECT_TIME: 'Select a time',
    },
    USER_LISTING: {
      SUBTITLE: 'Manage user accounts, roles, and access status.',
      FILTER: 'Filter',
      FILTER_APPLY: 'Apply',
      FILTER_CLEAR: 'Clear',
      FILTER_CANCEL: 'Cancel',
      FILTER_ALL: 'All',
      FILTER_NAME_PLACEHOLDER: 'Filter by name',
      COLUMN_NAME_SORT: 'Sort by name',
      COLUMN_START_DATE_SORT: 'Sort by start date',
      COLUMN_END_DATE_SORT: 'Sort by end date',
      ADD_USER: 'Add User',
      COLUMN_NAME: 'Name',
      COLUMN_ROLE: 'Role',
      COLUMN_STATUS: 'Status',
      COLUMN_START_DATE: 'Start Date',
      COLUMN_END_DATE: 'End Date',
      COLUMN_LAST_LOGIN: 'Last Login',
      USER_INFORMATION: 'User Information',
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      FIRST_NAME_REQUIRED: 'First name is required',
      LAST_NAME_REQUIRED: 'Last name is required',
      NAME_MIN_LENGTH: 'First or last name must be at least 2 characters long',
      NAME_MAX_LENGTH: 'First or last name must be at most 128 characters',
      NAME_INVALID_PATTERN: 'First or last name must contain only letters, spaces, hyphens, apostrophes, or dots',
      EMAIL: 'Email',
      EMAIL_TOOLTIP: 'Email address must be active',
      EMAIL_REQUIRED: 'Email is required',
      EMAIL_INVALID: 'Email is not valid',
      ROLE: 'Role',
      ROLE_SELECT: 'Select role',
      ROLE_REQUIRED: 'Role is required',
      PHONE: 'Phone',
      PHONE_INVALID: 'Phone is required and must contain digits only',
      PHONE_MIN_LENGTH: 'Phone must be at least 7 digits',
      PHONE_MAX_LENGTH: 'Phone must be at most 15 digits',
      BIRTH_DATE: 'Birth Date',
      BIRTH_DATE_FUTURE: 'Birth date cannot be in the future',
      GENDER: 'Gender',
      GENDER_UNKNOWN: 'Unknown',
      GENDER_FEMALE: 'Female',
      GENDER_MALE: 'Male',
      GENDER_OTHER: 'Other',
      EMPLOYMENT_INFORMATION: 'Employment Information',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      STATUS: 'Status',
      STATUS_NEW_ACCOUNT: 'New Account',
      STATUS_ACTIVE: 'Active',
      STATUS_PASSIVE: 'Passive',
      STATUS_DELETED: 'Deleted',
      PASSWORD: 'Password',
      PASSWORD_REQUIRED: 'Password is required',
      PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters long',
      RESET_PASSWORD: 'Reset Password',
      RESET_PASSWORD_FOR: 'Set a new password for {{name}}',
      NEW_PASSWORD: 'New Password',
      NEW_PASSWORD_CONFIRM: 'Confirm New Password',
      PASSWORDS_MUST_MATCH: 'Passwords do not match',
      PASSWORD_RESET_SUCCESS: 'User password updated successfully!',
      EDIT_USER: 'Edit User',
      DELETE_USER: 'Delete User',
      USER_DELETED: 'User deleted successfully!',
      EMPTY_STATE: 'No users found',
      LOAD_ERROR: 'Users could not be loaded',
      DISCARD: 'Discard',
      SUBMIT: 'Submit',
      PLEASE_WAIT: 'Please wait...',
      SUCCESS_TITLE: 'Success!',
      USER_UPDATED: 'User updated successfully!',
      USER_CREATED: 'User created successfully!',
      ERROR_TITLE: 'Error!',
      CONFIRM_OK: 'Ok, got it!',
    },
    SYSTEM_ROLES: {
      Admin: 'Admin',
      FrontDesk: 'Front Desk',
      DamageAnalysis: 'Damage Analysis',
      WorkshopManager: 'Workshop Manager',
      Accounting: 'Accounting',
      Bodywork: 'Bodywork',
      Mechanical: 'Mechanical',
      Electrical: 'Electrical',
      Paint: 'Paint',
      Washing: 'Washing',
    },
    THEME: {
      LIGHT: 'Light',
      DARK: 'Dark',
      SYSTEM: 'System',
    },
    WORKLIST_LISTING: {
      SUBTITLE: 'Review assigned work and pending actions.',
      COLUMN_CASE: 'Vehicle Plate',
      COLUMN_VEHICLE_INFO: 'Car information',
      COLUMN_RESPONSIBLE: 'Responsible',
      COLUMN_ACTION: 'Required action',
      COLUMN_UPDATED_DATE: 'Updated date',
      VIEW_RECORD: 'Open record',
      EMPTY_STATE: 'No worklist records found',
      LOAD_ERROR: 'Worklist could not be loaded',
      ACTION_COMPLETE_DAMAGE_ANALYSIS: 'Complete damage analysis',
      ACTION_UPDATE_PART_STATUS: 'Update part status',
      ACTION_APPROVE_COMPLETED_WORK: 'Approve completed work',
      ACTION_ROUTE_TO_WORKSHOPS: 'Route work to workshops',
      ACTION_ASSIGN_TECHNICIAN: 'Assign technician',
      ACTION_START_WORK: 'Start work',
      ACTION_COMPLETE_WORK: 'Complete work',
      ACTION_RESUME_WORK: 'Resume work',
      ACTION_COMPLETE_ACCOUNTING_CHECK: 'Complete accounting check',
      ACTION_DELIVER_VEHICLE: 'Complete delivery',
      ACTION_OPEN_CASE: 'Open case',
      RESPONSIBLE_ROLE_DamageAnalysis: 'Damage Analysis',
      RESPONSIBLE_ROLE_WorkshopManager: 'Workshop Manager',
      RESPONSIBLE_ROLE_FrontDesk: 'Front Desk',
      RESPONSIBLE_ROLE_Accounting: 'Accounting',
      RESPONSIBLE_ROLE_UNKNOWN: '-',
    },
    FOLLOWED_CASES: {
      SUBTITLE: 'View recent activity for the cases you follow.',
      COLUMN_CASE: 'Vehicle Plate',
      COLUMN_VEHICLE_INFO: 'Vehicle information',
      COLUMN_LAST_ACTIVITY: 'Last activity',
      COLUMN_DATE: 'Date',
      VIEW_RECORD: 'Open record',
      EMPTY_STATE: 'No active cases to follow',
      LOAD_ERROR: 'Followed cases could not be loaded',
      ACTIVITY_CASE_CREATED: {
        TITLE: 'Vehicle registered',
        DETAIL: 'You registered this vehicle.',
      },
      ACTIVITY_TECHNICIAN_ASSIGNED: {
        TITLE: 'Assigned to work',
        DETAIL: 'You were assigned to {{work}}.',
      },
    },
    PERFORMANCE_TRACKING: {
      TITLE: 'Performance Reports',
      SUBTITLE: 'Review team output and work completion times.',
      PERIOD_SELECTOR: 'Period selector',
      PERIOD_WEEKLY: 'This Week',
      PERIOD_MONTHLY: 'This Month',
      PERIOD_YEARLY: 'This Year',
      COLUMN_NAME: 'Name',
      COLUMN_ROLE: 'Role',
      COLUMN_COMPLETED: 'Completed',
      COLUMN_ACTIVE: 'Active Work',
      COLUMN_AVERAGE_TIME: 'Avg. Time',
      TOTAL_COMPLETED: 'Total {{count}} completed works',
      LOAD_ERROR: 'Performance data could not be loaded',
      DETAIL_LOAD_ERROR: 'Worker detail could not be loaded',
      EMPTY_STATE: 'No performance records found',
      LATEST_CASES: 'Latest Worked Cases',
      EMPTY_EVENTS: 'No recent activity found',
      ACTIVITY_TIMELINE: 'Activity Timeline',
      NOT_AVAILABLE: '-',
      HOURS_FORMAT: '{{value}} hrs',
      PLATE: 'Plate',
      GO_TO_CASE: 'Go to Case',
    },
    DASHBOARD: {
      PERFORMANCE_OVERVIEW: 'Performance Overview',
      TOTAL_CASES: 'Total Cases',
      CASE_STATUS_SUMMARY: 'Case status summary',
      SUMMARY_WIDGETS: 'Dashboard summary',
      ARRIVAL_APPOINTMENTS: 'Arrival Appointments',
      DELIVERY_APPOINTMENTS: 'Delivery Appointments',
      WORKSHOP_VEHICLES: 'Vehicles in Workshop',
      IN_REPAIR: 'In Repair',
      DELIVERED_THIS_MONTH: 'Delivered This Month',
      STATUS_GROUP_WAITING: 'Waiting',
      STATUS_GROUP_WAITING_DESCRIPTION: 'Awaiting photos, analysis, parts, or work to begin.',
      STATUS_GROUP_IN_PROGRESS: 'In Progress',
      STATUS_GROUP_IN_PROGRESS_DESCRIPTION: 'Work is currently underway.',
      STATUS_GROUP_DONE: 'Done',
      STATUS_GROUP_DONE_DESCRIPTION: 'Ready for delivery or already delivered.',
      REGISTERED: 'Registered',
      QUEUED_CASES: 'Waiting in Queue',
      IN_SERVICE: 'In Service',
      READY_FOR_DELIVERY: 'Ready for Delivery',
      DELIVERED: 'Delivered',
      CASES_BY_STATUS: 'Cases by Status',
      CASES_BY_STATUS_PERIOD: 'Cases by status period',
      PERIOD_WEEKLY: 'Weekly',
      PERIOD_MONTHLY: 'Monthly',
      PERIOD_YEARLY: 'Yearly',
      UPCOMING_APPOINTMENTS: 'Upcoming Appointments',
      OPEN_CALENDAR: 'Open Calendar',
      VIEW_ALL: 'View All',
      PLATE: 'Plate',
      CUSTOMER: 'Customer',
      EVENT: 'Event',
      USER: 'User',
      STATUS: 'Status',
      EXPECTED_DELIVERY: 'Delivery Appointment',
      APPOINTMENT_TIME: 'Appointment Time',
      ARRIVAL_APPOINTMENT: 'Arrival Appointment',
      DELIVERY_APPOINTMENT: 'Delivery Appointment',
      LAST_UPDATE: 'Last Update',
      LOADING: 'Loading...',
      LOAD_ERROR: 'Failed to load dashboard data',
      RETRY: 'Retry',
      NO_DATA: 'No data available',
      STATUS_REGISTERED: 'Registered',
      STATUS_WAITING_IN_QUEUE: 'Waiting in Queue',
      STATUS_IN_SERVICE: 'In Service',
      STATUS_READY_FOR_DELIVERY: 'Ready for Delivery',
      STATUS_DELIVERED: 'Delivered',
      TIME_JUST_NOW: 'just now',
      TIME_MINUTES: '{{count}}m ago',
      TIME_HOURS: '{{count}}h ago',
      TIME_DAYS: '{{count}}d ago',
      LATEST_UPDATES: 'Latest Updates',
    },
    AUTH: {
      BRAND: {
        SUBTITLE: 'OTOMOTO SİSTEMİ YÖNETİMİ',
      },
      ASIDE: {
        IMAGE_ALT: 'MOTO platform screens',
        TITLE: 'Manage operations in one flow',
        TEXT: 'Track files, worklists, and team processes from one panel. Daily operations move forward more clearly, faster, and more orderly.',
      },
      LOGIN: {
        TITLE: 'Login Account',
        SUBTITLE: 'Continue with your MOTO account',
        BUTTON: 'Sign In',
        LOADING: 'Please wait...',
        SHOW_PASSWORD: 'Show password',
        HIDE_PASSWORD: 'Hide password',
      },
      INPUT: {
        EMAIL: 'Email',
        PASSWORD: 'Password',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        MAX_LENGTH: '{{name}} maximum length is {{max}}',
        INVALID_LOGIN: 'The login detail is incorrect',
      },
    },
  },
};
